<template>
  <div class="content-430">
    <div class="history flex justify-content_end" style="margin-bottom: 10px">
      <div v-if="!showHint" class="dark-modal"></div>
      <Button
        type="primary"
        @click="handleTistory"
      >原账单合并展示模式入口 >></Button>
      <div v-if="!showHint" class="history-bg">
        <Button
          type="primary"
          @click="handleTistory"
        >原账单合并展示模式入口 >></Button>
      </div>
      <img v-if="!showHint" class="line" src="./assets/image/line.png">
      <div v-if="!showHint" class="history-str">
        2023年11月及以前账单合并展示模式入口在这里～
      </div>
      <div v-if="!showHint" class="close" @click="handleClose">关闭</div>
    </div>
    <div class="header-wrapper-430">
      <SearchBlock
        @on-finish="onSearchFinish"
        @on-download="onDownload"
      ></SearchBlock>
    </div>

    <template v-if="!searchParameter">
      <SettlementDefaultPage></SettlementDefaultPage>
    </template>

    <template v-else>
      <Count v-show="portOrg == 1" ref="countRef"></Count>
      <SettlementTable
        ref="settlementTableRef"
        :table-data="tableData"
        :search-parameter="searchParameter"
        :loading="loading"
        @on-uploadStaSts="onUploadStaSts"
      ></SettlementTable>
      <SettlementPage
        ref="settlementPageRef"
        :total="pageInfo.total"
        @on-page-change="onPageChange"
      ></SettlementPage>

      <p v-if="false" class="hint">提示：只展示最近6个月的结算账单</p>
    </template>
  </div>
</template>

<script>
import SearchBlock from './assets/components/SearchBlock.vue';
import SettlementTable from './assets/components/SettlementTable.vue';
import SettlementPage from './assets/components/SettlementPage.vue';
import SettlementDefaultPage from './assets/components/SettlementDefaultPage.vue';
import { getSearchsStorage, setSearchsStorage } from '@/utils/storage';
import Count from './assets/components/Count.vue';
import orderCenterApi from '@/request/orderCenter/index.js';
import { downLoadByBlob } from '@/pages/assetsModules/common.js';
import { mapState, mapActions, mapMutations } from 'vuex';

export default {
  name: 'FinanceCenterSettlementIndexList',
  components: {
    SearchBlock,
    SettlementTable,
    SettlementPage,
    SettlementDefaultPage,
    Count

  },

  beforeRouteEnter(to, from, next) {
    const fromName = from && from.name;

    next(vm => {
      vm.tableType = vm.$route.meta.tableType;
      vm.searchParameter = null;
      vm.tableData = [];
      vm.pageInfo = {
        pageNum: 1,
        pageSize: 10,
        total: 0
      };
      vm.handleShowHint();
    });
  },

  data() {
    return {
      tableType: this.$route.meta.tableType,
      tableData: [],
      pageInfo: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      searchParameter: null,
      searchCache: null,
      loading: false,
      portOrg: localStorage.getItem('portOrg'),
      userInfo: null,
      fakeData: [
        {
          'settleMonth': '2023-07',
          'stsDate': '2023-09-18 16:27:24',
          'attachmentPrice': '0',
          'classroomFee': '7808000',
          'daycare': '42224350',
          'totalFee': '50032350',
          'orgFee': null,
          'yearCode': 9,
          'termCode': 1,
          'yearTerm': '2023-2024第一学期',
          'bankType': 1,
          'bankId': '10001'
        },
        {
          'settleMonth': '2023-06',
          'stsDate': '2023-10-22 10:15:39',
          'attachmentPrice': '0',
          'classroomFee': '221532500',
          'daycare': '316929100',
          'totalFee': '538461600',
          'orgFee': null,
          'yearCode': 9,
          'termCode': 1,
          'yearTerm': '2023-2024第一学期',
          'bankType': 1,
          'bankId': '10001'
        },
        {
          'settleMonth': '2023-05',
          'stsDate': '2023-10-22 10:15:39',
          'attachmentPrice': '4500',
          'classroomFee': '255927900',
          'daycare': '376388400',
          'totalFee': '632320800',
          'orgFee': null,
          'yearCode': 9,
          'termCode': 1,
          'yearTerm': '2023-2024第一学期',
          'bankType': 1,
          'bankId': '10001'
        },
        {
          'settleMonth': '2023-04',
          'stsDate': '2023-09-19 18:20:39',
          'attachmentPrice': '0',
          'classroomFee': '238448600',
          'daycare': '355241050',
          'totalFee': '593689650',
          'orgFee': null,
          'yearCode': 9,
          'termCode': 1,
          'yearTerm': '2023-2024第一学期',
          'bankType': 1,
          'bankId': '10001'
        },
        {
          'settleMonth': '2023-03',
          'stsDate': '2023-10-11 10:00:39',
          'attachmentPrice': '158000',
          'classroomFee': '279693800',
          'daycare': '413625300',
          'totalFee': '693477100',
          'orgFee': null,
          'yearCode': 9,
          'termCode': 1,
          'yearTerm': '2023-2024第一学期',
          'bankType': 1,
          'bankId': '10001'
        },
        {
          'settleMonth': '2023-02',
          'stsDate': '2023-10-12 11:42:46',
          'attachmentPrice': '90356600',
          'classroomFee': '156257300',
          'daycare': '280967700',
          'totalFee': '527581600',
          'orgFee': null,
          'yearCode': 9,
          'termCode': 1,
          'yearTerm': '2023-2024第一学期',
          'bankType': 1,
          'bankId': '10001'
        }
      ],
      showHint: true

    };
  },
  watch: {
    $route: {
      handler: function(val, oldVal) {

      },
      // 深度观察监听
      deep: true
    }
  },
  created() {
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
    this.handleShowHint();
  },
  activated() {

  },
  methods: {
    // 搜索完成
    onSearchFinish(val) {
      console.log(val, '搜索拿到的参数000000');
      this.searchParameter = val;
      this.pageInfo.pageNum = 1;
      this.$refs.settlementPageRef && this.$refs.settlementPageRef.init();
      this.$nextTick(() => {
        this.handleRequestTable(val);
      });
    },
    cacheSearch() {
      this.onSearchFinish(this.searchParameter);
    },
    // 点击下载
    onDownload(val) {
      this.handleRequestDownload(val);
    },
    // 页码改变
    onPageChange(pageInfo) {
      this.pageInfo.pageNum = pageInfo.pageNum;
      this.pageInfo.pageSize = pageInfo.pageSize;
      this.handleRequestTable(this.searchParameter);
    },

    // 处理请求接口
    handleRequestTable(val) {
      console.log(val, this.tableType, '拿到的数据000');
      if ([0, 2, 3].includes(val.portOrg) && val.tableType == 1) {
        this.getUserOrderListTallyByOrg(val);
        return null;
      }
      if ([0, 2].includes(val.portOrg) && val.tableType == 2) {
        this.getUserOrderListTallyBySch(val);
        return null;
      }
      if ([0, 1].includes(val.portOrg) && val.tableType == 3) {
        this.getUserOrderlistTallyByEdu(val);
        return null;
      }
    },
    // 处理下载接口
    handleRequestDownload(val) {
      if ([0, 2].includes(val.portOrg) && val.tableType == 1) {
        this.exportAgencyBillList(val);
        return null;
      }
      if (val.tableType == 2) {
        this.exportListSchoolTally(val);
        return null;
      }
    },
    // 机构类列表数据
    async getUserOrderListTallyByOrg(val) {
      console.log(val);
      const { orgId, schId: schoolId, bankId, approvalSts, settleSts, isShowZero, settleMonth, statementId: sheetId, settlementSheetOrgId, yearCode, termCode } = val.data;
      const { pageNum, pageSize } = this.pageInfo;

      let res; const parameter = { yearCode, termCode, orgId: orgId == 0 ? null : orgId, bankId: bankId == '-1' ? null : bankId, pageNum, pageSize, settleMonth: settleMonth || null, sheetId, settlementSheetOrgId: settlementSheetOrgId == 0 ? null : settlementSheetOrgId, schoolId: schoolId != '0' ? schoolId : null };
      this.loading = true;
      parameter.approvalSts = approvalSts == -1 ? null : approvalSts;
      parameter.settleSts = settleSts == -1 ? null : settleSts;

      if (val.portOrg == 0 || val.portOrg == 2) {
        parameter.isShowZero = isShowZero;
      } else if (val.portOrg == 3) {

      }

      res = await orderCenterApi.getSubSheetListPage(parameter);
      this.loading = false;
      if (res.status == 200) {
        const { total, list } = res.message;
        const target = ['availBal', 'settleAvailAmt', 'endAvailBal', 'commission', 'merchantPoundage', 'platformPoundage', 'platAmt', 'platTotalAmt', 'realPlatAmt', 'merchantAmt', 'noonCareAmt', 'lateCareAmt', 'fullCareAmt', 'attachmentPrice', 'classroomFee'];
        // list.forEach(item => {
        //   item.orgId = item.offerOrgId
        //   item.orgName = item.offerOrgName
        // })

        this.handleEventTableData(list, target);
        this.pageInfo.total = Number(total);
        // 机构端 未经过运营确认 要处理
        if (val.portOrg == 3 || val.portOrg == 2) {
          list.forEach(item => {
            if (item.approvalSts == 1 || item.approvalSts == 0) {
              [...target, 'tallyCount'].forEach(item_1 => {
                item[item_1] = '***';
              });
              // item.availBal = '***';
              // item.settleAvailAmt = '***';
              // item.endAvailBal = '***';
              // item.commission = '***';
              // item.platAmt = '***';
              // item.platTotalAmt = '***';
              // item.noonCareAmt = '***';
              // item.lateCareAmt = '***';
              // item.fullCareAmt = '***';
              // item.attachmentPrice = '***';
              // item.classroomFee = '***';
            }
          });
        }
        this.tableData = list;
      }
    },
    // 学校类列表数据
    async getUserOrderListTallyBySch(val) {
      const { schId: schoolId, bankId, settleMonth, termCode, yearCode } = val.data;
      const { pageNum, pageSize } = this.pageInfo;
      const parameter = { schoolId: schoolId != '0' ? schoolId : null, bankId: bankId != '-1' ? bankId : null, settleMonth: settleMonth || null, pageNum, pageSize, termCode, yearCode };
      // let res;
      this.loading = true;
      const res = await orderCenterApi.getSchoolSheetListPage(parameter);
      this.loading = false;

      if (res.status == 200) {
        const { list, total } = res.message;
        list.forEach((item, key) => {
          item.statementId = ++key;
          item.settlementTime = item.stsDate;
          if (item.settleMonth) {
            item.beginTime = item.settleMonth;
          }
          item.beginDate = item.beginTime;
        });

        this.handleEventTableData(list, ['totalFee', 'platServiceFee', 'noonCare', 'lateCare', 'fullCare', 'attachmentPrice', 'classroomFee', 'attachmentPriceSch', 'attachmentPriceOrg', 'classroomFeeSch', 'classroomFeeOrg']);
        this.pageInfo.total = Number(total);
        this.tableData = list;
      }
    },
    // 查询结算账单列表-教育局端
    async getUserOrderlistTallyByEdu(val) {
      this.loading = true;
      let res = null;
      const { pageNum, pageSize } = this.pageInfo;

      const parameter = {
        yearCode: val.data.yearCode,
        termCode: val.data.termCode,

        eduId: val.data.eduId,
        beginTime: val.data.settleMonth ? val.data.settleMonth : null,
        pageNum,
        pageSize
      };
      if (val.portOrg == 0) {
        // console.log('parameterparameter', val, parameter)
        res = await orderCenterApi.getUserOrderlistTallyByAdmin(parameter);
      } else {
        parameter.areaCode = this.userInfo.areaCode;
        this.$refs.countRef && this.$refs.countRef.getEduBillStatisticsForEdu(parameter);
        res = await orderCenterApi.getUserOrderlistTallyByEdu(parameter);
      }

      this.loading = false;
      if (res.data.status == 200 && this.userInfo.orgId === '614867004922269697') {
        const { list, total } = res.data.message;
        // const { message } = res.data;
        const fakeList = [...list, ...this.fakeData];
        fakeList.forEach((item, key) => {
          item.statementId = ++key;
          item.settlementTime = item.stsDate;
          item.settleTime = item.stsDate;
          item.eduId = val.data.eduId;
          if (item.settleMonth) {
            item.beginTime = item.settleMonth;
          }
          item.beginDate = item.beginTime;
        });
        this.handleEventTableData(fakeList, ['daycare', 'attachmentPrice', 'classroomFee', 'totalFee', 'orgFee']);
        this.pageInfo.total = +total + 6;
        this.tableData = fakeList;
      } else if (res.data.status == 200) {
        const { list, total } = res.data.message;
        // const { message } = res.data;

        list.forEach((item, key) => {
          item.statementId = ++key;
          item.settlementTime = item.stsDate;
          item.settleTime = item.stsDate;
          item.eduId = val.data.eduId;
          if (item.settleMonth) {
            item.beginTime = item.settleMonth;
          }
          item.beginDate = item.beginTime;
        });
        this.handleEventTableData(list, ['daycare', 'attachmentPrice', 'classroomFee', 'totalFee', 'orgFee']);
        this.pageInfo.total = Number(total);
        this.tableData = list;
      }
    },
    //  处理金额参数
    handleEventTableData(val, targets) {
      val.forEach(item => {
        targets.forEach(target => {
          try {
            item[target] === null || item[target] === undefined ? item[target] = 0 : '';
            item[target] = this.abs(parseInt(item[target]));
          } catch (err) {

          }
        });
      });
    },
    // //金额转换 分->元 保留2位小数 并每隔3位用逗号分开 1,234.56
    abs(val) {
      const str = (val / 100).toFixed(2) + '';
      const intSum = str.substring(0, str.indexOf('.')).replace(/\B(?=(?:\d{3})+$)/g, ',');// 取到整数部分
      const dot = str.substring(str.length, str.indexOf('.'));// 取到小数部分搜索
      const ret = intSum + dot;
      return ret;
    },
    // 下载学校确认单表格
    async exportListSchoolTally(val) {
      const { schId: schoolId, bankId: bankType, settleMonth, yearCode, termCode } = val.data;

      let res; const parameter = { schoolId: schoolId != 0 ? schoolId : null, bankId: bankType != -1 ? bankType : null, settleMonth: settleMonth != 0 ? settleMonth : null, yearCode, termCode };
      this.$Spin.show();

      // if (val.portOrg == 0) {

      res = await orderCenterApi.exportSchoolSheetList(parameter);
      // }
      this.$Spin.hide();
      if (res.data.type === 'application/vnd.ms-excel') {
        this.$Message.success('导出成功');
        downLoadByBlob(res);
      } else {
        this.$Message.error('导出失败');
      }
    },
    async exportAgencyBillList(val) {
      const { orgId, bankId, approvalSts, settleSts, isShowZero, settleMonth, statementId: sheetId, settlementSheetOrgId, yearCode, termCode, schId: schoolId } = val.data;
      const { pageNum, pageSize } = this.pageInfo;

      let res; const parameter = { yearCode, termCode, orgId: orgId == 0 ? null : orgId, bankId: bankId == '-1' ? null : bankId, pageNum, pageSize: 3000, settleMonth: settleMonth || null, sheetId, settlementSheetOrgId: settlementSheetOrgId == 0 ? null : settlementSheetOrgId, schoolId: schoolId != '0' ? schoolId : null };
      //  this.loading = true;
      parameter.approvalSts = approvalSts == -1 ? null : approvalSts;
      parameter.settleSts = settleSts == -1 ? null : settleSts;
      //  运营端 或者 机构端， 处理银行参数bankType
      // if (val.portOrg == 0 || val.portOrg == 3) {
      //   !parameter.bankId ? parameter.bankId = [10001, 10002, 10003] : '';
      //   parameter.bankId == 'wChat' ? parameter.bankId = [0] : '';
      // }

      // 测试 删除银行bankId
      //  delete parameter.bankId
      this.$Spin.show();
      if (val.portOrg == 0 || val.portOrg == 2) {
        parameter.isShowZero = isShowZero;
        res = await orderCenterApi.exportSubSheetList(parameter);
      }
      this.$Spin.hide();
      if (res.data.type === 'application/vnd.ms-excel') {
        this.$Message.success('导出成功');
        downLoadByBlob(res);
      } else {
        this.$Message.error('导出失败');
      }
    },
    onUploadStaSts() {
      this.$nextTick(() => {
        this.handleRequestTable(this.searchParameter);
      });
    },
    handleShowHint() {
      console.log('0-----------------------');
      console.log(`financeCenter_Settlement_hint` + this.tableType);
      console.log(Boolean(getSearchsStorage(`financeCenter_Settlement_hint` + this.tableType)));
      // this.showHint = Boolean(getSearchsStorage(`financeCenter_Settlement_hint` + this.tableType));
      this.showHint = true;
    },
    handleClose() {
      setSearchsStorage(true, `financeCenter_Settlement_hint` + this.tableType);
      this.handleShowHint();
    },
    handleTistory() {
      let urlName = '';
      switch (Number(this.tableType)) {
        case 1:
          const map1 = {
            0: 'financeCenter_oldSettlement_org',
            2: 'financeCenter_oldSettlement_org', // 学校
            3: 'financeCenter_oldSettlement_org' // 机构
          };
          urlName = map1[Number(this.portOrg)];
          break;
        case 2:
          const map2 = {
            0: 'financeCenter_oldSettlement_sch',
            2: 'financeCenter_oldSettlement_sch' // 学校
          };
          urlName = map2[Number(this.portOrg)];
          break;
        case 3:
          const map3 = {
            0: 'financeCenter_oldSettlement_edu',
            1: 'financeCenter_oldSettlement_edu'
          };
          urlName = map3[Number(this.portOrg)];
          break;
      }
      const routeUrl = this.$router.resolve({
        name: urlName
      });

      window.open(routeUrl.href, '_blank');
    }

  }
};
</script>

<style lang="scss" scoped>
.hint {
  padding: 16px 0;
  color: #999;
}
.dark-modal {
  position: fixed;
  left: 0px;
  top: 0px;
  right: 0px;
  bottom: 0px;
  background: rgba(000, 000, 000, 0.5);
  z-index: 3000;
}
.history {
  position: relative;
  .history-bg {
    position: absolute;
    z-index: 3001;
    right: -4px;
    top: -8px;
    padding: 8px;
    border-radius: 6px;
    background: #ffffff;
  }
  .line {
    width: 10px;
    height: 100px;
    position: absolute;
    z-index: 3001;
    top: 45px;
    right: 161px;
  }
  .history-str {
    background-image: url('./assets/image/promptBox.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: right;
    font-size: 14px;
    color: #fff;
    text-align: center;
    width: 350px;
    height: 52px;
    line-height: 62px;

    position: absolute;
    top: 152px;
    right: -8px;
    z-index: 3001;
  }
  .close {
    border: 1px solid #fff;
    color: #fff;
    width: 70px;
    height: 36px;
    border-radius: 24px;
    line-height: 36px;
    text-align: center;
    position: absolute;
    top: 222px;
    right: 134px;
    z-index: 3001;
    cursor: pointer;
  }
}
</style>
